import { SelectionMode } from '@fluentui/react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import React, { Component, Fragment } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataActualite } from '../../data/DataActualite';
import { DataMonCompte } from '../../data/DataMonCompte';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheActualite } from '../Fiche/FicheActualite/FicheActualite';

export class DetailsListActualite extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListActualiteWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

// KP - 19/09/2023 : composant raccordé à ImmocomContext pour tests
class DetailsListActualiteWithPerimetre extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        itemActif: {},
        items: [],
        itemsSelectionnes: [],
        peutEditerActualiteNationale: false,
        /* --- */
        afficherDialogPublicationActualite: false,
        afficherDialogSuppressionActualite: false,
        afficherPanelEditerActualite: false,
        pageIndex: 1,
        facteurNbreEnregistrement: 100,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListActualiteWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = true;
        this._sortedColumn = "creerLe";
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this._togglePanel("Filtres", false, null, this._chargementDonnees)();
    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des actualités en cours...");

        const { facteurNbreEnregistrement, pageIndex } = this.state;

        DataActualite._chargementListeDesActualites(this._filtres, this._sortedColumn, this._isSortedDescending, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const newItems = responseFetch.reponseAPIobjet || [];

                let items = [];
                if (pageIndex === 1) items = newItems;
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const state = { items: newItems };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                fetchMessages(responseFetch);
                this.setState({ items: [] });
            }
            dismissMessage(messageId);
        });
    };

    _chargementDroits = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des droits en cours...");

        DataMonCompte._chargementDroitsLiesAuxActualites().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const { peutEditerActualiteNationale } = responseFetch.reponseAPIobjet;
                const state = { peutEditerActualiteNationale };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _publierActualite = (idActualite) => () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Publication en cours...");

        DataActualite._onPublicationActualite(idActualite).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _publierActualites = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Publication en cours...");

        const { itemsSelectionnes } = this.state;

        DataActualite._onPublicationActualites(itemsSelectionnes).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _supprimerActualite = (idActualite) => () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Suppression en cours...");

        DataActualite._onSuppressionActualite(idActualite).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _supprimerActualites = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Suppression en cours...");

        const { itemsSelectionnes } = this.state;

        DataActualite._onSuppressionActualites(itemsSelectionnes).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });
    };

    _getColumns = () => {

        const { peutEditerActualiteNationale } = this.state;

        return [{
            key: 'idActualite',
        }, {
            key: 'nomCommercial',
            minWidth: 70,
            maxWidth: 200,
            name: 'Opération',
        }, {
            key: 'description',
            name: 'Description',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: 'creerLe',
            name: 'Créée le',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: 'creerPar',
            minWidth: 150,
            maxWidth: 150,
            name: 'Créée par',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: 'datePublication',
            name: 'Publiée le',
        }, {
            ariaLabel: "Modifier l'actualité",
            isIconOnly: true,
            key: "edition",
            onRender: (item) => {
                return <IconButton
                    ariaLabel="Modifier l'actualité"
                    iconProps={{ iconName: 'Edit' }}
                    onClick={this._togglePanel("EditerActualite", true, item)}
                    title="Modifier l'actualité"
                />;
            }
        }, {
            ariaLabel: "Publier l'actualité",
            isIconOnly: true,
            key: 'publish',
            onRender: (item) => {
                return <IconButton
                    ariaLabel="Publier l'actualité"
                    iconProps={{ iconName: 'PublishContent' }}
                    onClick={this._toggleDialog("PublicationActualite", true, item)}
                    title="Publier l'actualité"
                    disabled={!!item.datePublication}
                />;
            }
        }, {
            ariaLabel: "Supprimer l'actualité",
            isIconOnly: true,
            key: 'delete',
            onRender: (item) => {
                return <IconButton
                    ariaLabel="Supprimer l'actualité"
                    disabled={item.nationale && !peutEditerActualiteNationale}
                    iconProps={{ iconName: 'Delete' }}
                    onClick={this._toggleDialog("SuppressionActualite", true, item)}
                    title="Supprimer l'actualité"
                />;
            }
        }];

    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getItems = () => {

        const { itemsSelectionnes, peutEditerActualiteNationale } = this.state;
        const actualiteNationaleSelectionnee = itemsSelectionnes.some(item => item.nationale);

        return [{
            iconProps: { iconName: "Add" },
            key: "nouveau",
            name: "Nouvelle actualité",
            onClick: this._togglePanel("EditerActualite", true, { idActualite: 0 })
        }, {
            disabled: itemsSelectionnes.length <= 0 || (actualiteNationaleSelectionnee && !peutEditerActualiteNationale),
            iconProps: { iconName: "Delete" },
            key: "delete",
            name: "Supprimer",
            onClick: this._toggleDialog("SuppressionActualites", true)
        }, {
            disabled: itemsSelectionnes.length <= 0 || (actualiteNationaleSelectionnee && !peutEditerActualiteNationale),
            iconProps: { iconName: "PublishContent" },
            key: "publish",
            name: "Publier",
            onClick: this._toggleDialog("PublicationActualites", true)
        }];

    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSelectionChanged = (items) => {
        this.setState({ itemsSelectionnes: items });
    };

    _onScroll = () => {
        const { facteurNbreEnregistrement } = this.state;
        if (facteurNbreEnregistrement > 0)
            this.setState(
                prevState => ({ pageIndex: prevState.pageIndex + 1 }),
                this._chargementDonnees
            );
    };

    _toggleDialog = (nomDialog, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount() {
        this._chargementDroits();
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const {
            afficherDialogSuppressionActualite, afficherDialogSuppressionActualites, afficherDialogPublicationActualite, afficherDialogPublicationActualites, afficherPanelEditerActualite, afficherPanelFiltres,
            itemActif, items, peutEditerActualiteNationale
        } = this.state;

        return <Fragment>

            {/* KP - 19/09/2023 : migration EUIDetailsList */}
            <EUIDetailsList
                columns={this._columns}
                getKey={item => item.idActualite}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onFilterButtonClick={this._togglePanel("Filtres", true)}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                onScroll={this._onScroll}
                onSearch={this._onSearch}
                onSelectionChanged={this._onSelectionChanged}
                selectionMode={SelectionMode.multiple}
                sortedColumn={this._sortedColumn}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onValidate={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
            />

            <FicheActualite
                idActualite={itemActif.idActualite}
                isOpen={afficherPanelEditerActualite}
                onDismiss={this._togglePanel("EditerActualite", false)}
                onSave={this._togglePanel("EditerActualite", false, {}, this._chargementDonnees)}
                peutEditerActualiteNationale={peutEditerActualiteNationale}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._toggleDialog("SuppressionActualite", false, {}, this._supprimerActualite(itemActif.idActualite))} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionActualite", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionActualite}
                onDismiss={this._toggleDialog("SuppressionActualite", false)}
                titre="Suppression d'actualité"
            >
                Vous êtes en train de supprimer cette actualité, voulez-vous continuer ?
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._toggleDialog("SuppressionActualites", false, {}, this._supprimerActualites)} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionActualites", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionActualites}
                onDismiss={this._toggleDialog("SuppressionActualites", false)}
                titre="Suppression d'actualités"
            >
                Vous êtes en train de supprimer ces actualités, voulez-vous continuer ?
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="publier" onClick={this._toggleDialog("PublicationActualite", false, {}, this._publierActualite(itemActif.idActualite))} text="Publier" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("PublicationActualite", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogPublicationActualite}
                onDismiss={this._toggleDialog("PublicationActualite", false)}
                titre="Publication d'actualité"
            >
                Vous êtes en train de publier cette actualité, voulez-vous continuer ?
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="publier" onClick={this._toggleDialog("PublicationActualites", false, {}, this._publierActualites)} text="Publier" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("PublicationActualites", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogPublicationActualites}
                onDismiss={this._toggleDialog("PublicationActualites", false)}
                titre="Publication d'actualités"
            >
                Vous êtes en train de publier ces actualités, voulez-vous continuer ?
            </EUIDialog>

        </Fragment>;
    };

};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
    };

    static defaultState = {
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        let filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

        </EUIPanel>;

    };

};